
import { parseMessages, clearAcceptIgnoreButtons } from "./chats";
import { cloneDeep, isEmpty } from "lodash";
// import { updateProfileImage } from "./updateProfileImage";
import {
	getDataFromLFStorage,
	LFStorageKeys,
	saveDataInLFStorage,
} from "../../services/storage/LFStorage";
import store from "../configureStore";
import { updateProfileImage } from './updateProfileImage';
import { CLEAR_ACCEPT_IGNORE_CONTACT } from '../constants';
import { UserServiceClientApi } from '../../services/api/UserApiServices';
import { getUserProfileImageUrlThumbnail } from "../../utils/general";
import webSocketApiService from "../../services/socket/wsApiServices";
export const CONTACTS_RECEIVED = "CONTACTS_RECEIVED";
export const FILTER_CONTACTS_IN_CATEGORIES = "FILTER_CONTACTS_IN_CATEGORIES";
export const UPDATE_PENDING_CONTACTS = "UPDATE_PENDING_CONTACTS";
export const UPDATE_SELECTED_PENDING_CONTACT = "UPDATE_SELECTED_PENDING_CONTACT";
export const SELECTED_CONTACT = "SELECTED_CONTACT";
export const REMOVE_SELECTED_CONTACT = "REMOVE_SELECTED_CONTACT";
export const NEW_CONTACT_ADDED_STATUS = "NEW_CONTACT_ADDED_STATUS";
export const REMOVE_CONTACT_STATUS = "REMOVE_CONTACT_STATUS";
export const VESSEL_CONTACT_PROFILE_IMG = "VESSEL_CONTACT_PROFILE_IMG";
export const UPDATE_CONTACT_FROM_LOCAL = "UPDATE_CONTACT_FROM_LOCAL";
export const UPDATE_CONTACT_FROM_ACCEPTED = "UPDATE_CONTACT_FROM_ACCEPTED";
export const UPDATE_IGNORED_CONTACT = "UPDATE_IGNORED_CONTACT";
// JUST clearing the selected contact not deleting for FC-647 purpose
export const CLEAR_SELECTED_CONTACT = "CLEAR_SELECTED_CONTACT";
export const ADD_NEW_USER_ASSOCIATION = "ADD_NEW_USER_ASSOCIATION";
export const SYNC_CONTACTS_WITH_CACHE = "SYNC_CONTACTS_WITH_CACHE";


export const filterContactsInCategories = (data) => {
	const dataSet = {
		directoryContacts: [],
		shipContacts: [],
		shoreContacts: [],
		allContacts: []
	};

	const hideData = { showChats: false, showVOIP: false, showVideoCall: false };
	const showData = { showChats: true, showVOIP: true, showVideoCall: true };

	const acceptedContacts = data.acceptedContacts.filter(
		item => !item.waitingForConfirmation && !item.showAcceptIgnoreMsg && !item.ignored
	);

	// ---------- Helpers ----------

	const findOrCreateSection = (collection, title, type = '') => {
		let section = collection.find(
			x => x.title.toLowerCase() === title.toLowerCase()
		);

		if (!section) {
			section = {
				title,
				type,
				contacts: [],
				count: 0
			};
			collection.push(section);
		}

		return section;
	};

	const getDirectoryTitle = (contact) => {
		const rank1 = (contact.rankLevel1 || '').toLowerCase();
		const rank2 = (contact.rankLevel2 || '').toLowerCase();
		const email = contact.emailAddresses;

		if (rank1 !== '' || rank2 !== '') return null;
        
		if (!email || email === 'null') {
			return 'Uncategorised';
		}

		return 'Personal';
	};

	// ---------- Accepted Contacts ----------

acceptedContacts.forEach((contactObj) => {
	const contact = { ...contactObj, ...showData };

	const rank1Raw = contact.rankLevel1 ?? '';
	const rank2Raw = contact.rankLevel2 ?? '';

	const rank1 = rank1Raw.trim().toLowerCase();
	const rank2 = rank2Raw.trim(); // keep original casing for title

	// ---------- SHIP ----------
	if (rank1 === 'ship') {
		const title = rank2 || rank1Raw.trim();

		const section = findOrCreateSection(
			dataSet.shipContacts,
			title,
			'ship'
		);

		section.contacts.push(contact);
		section.count++;
		return;
	}

	// ---------- SHORE ----------
	if (rank1 === 'shore') {
		const title = rank2 || rank1Raw.trim();

		const section = findOrCreateSection(
			dataSet.shoreContacts,
			title,
			'shore'
		);

		section.contacts.push(contact);
		section.count++;
		return;
	}

	// ---------- RANK2 ONLY (rank1 empty but rank2 exists) ----------
	if (!rank1 && rank2) {
		const title = rank2;

		// choose where these should live (ship is most common)
		const section = findOrCreateSection(
			dataSet.shipContacts,
			title,
			'ship'
		);

		section.contacts.push(contact);
		section.count++;
		return;
	}

	// ---------- DIRECTORY (ONLY if BOTH empty) ----------
	if (!rank1 && !rank2) {
		const email = contact.emailAddresses;
		const directoryTitle =
			!email || email === 'null' ? 'Uncategorised' : 'Personal';

		const section = findOrCreateSection(
			dataSet.directoryContacts,
			directoryTitle,
			'Directory'
		);

		section.contacts.push({
			...contact,
			...(directoryTitle === 'Uncategorised' ? showData : hideData)
		});
		section.count++;
	}
});





	// ---------- Domain Contacts (Directory only) ----------

	data.domainContacts.forEach((contactObj) => {
		const contact = { ...contactObj, ...showData, isDirectoryContact: true };
		const title = contact.rankLevel2 || 'Uncategorised';

		const section = findOrCreateSection(
			dataSet.directoryContacts,
			title,
			'Directory'
		);

		section.contacts.push(contact);
		section.count++;
	});

	// ---------- Local Contacts (Personal) ----------

	data.localContacts.forEach((contactObj) => {
		const contact = { ...contactObj, ...hideData };
		const title = contact.rankLevel2 || 'Personal';

		const section = findOrCreateSection(
			dataSet.directoryContacts,
			title,
			'Directory'
		);

		section.contacts.push(contact);
		section.count++;
	});

	// ---------- Final Visibility Fix ----------
	dataSet.directoryContacts.forEach((group) => {
		const isUncategorised = group.title.toLowerCase() === 'uncategorised';
		group.contacts = group.contacts.map(contact => ({
			...contact,
			...(isUncategorised ? showData : hideData)
		}));
	});

	return {
		directoryContacts: dataSet.directoryContacts,
		shipContacts: dataSet.shipContacts,
		shoreContacts: dataSet.shoreContacts,
		allContacts: [
			...dataSet.directoryContacts,
			...dataSet.shipContacts,
			...dataSet.shoreContacts
		]
	};
};


export const fetchContacts = (data, forceFetchContact = false) =>
	async (dispatch, getState) => {
		console.log("fetchContacts", data);
		try {
			let contactsList =
				(await getDataFromLFStorage(`${LFStorageKeys.CONTACTS}_${data.selectedDomain}`)) || [];
			if (forceFetchContact || isEmpty(contactsList)) {
				try {
					contactsList = await webSocketApiService.GetContacts(data);
					console.log("contactsList", contactsList);
				} catch (error) {
					console.error("ERROR in fetching Contacts", error);
				}

				// const loggedInUser = getState()?.user?.user;

				// if (contactsList?.data && loggedInUser) {
				// 	if (!Array.isArray(contactsList.data.contacts)) {
				// 		contactsList.data.contacts = [];
				// 	}

				// 	const alreadyExists = contactsList.data.contacts.some(
				// 		(c) => c?.userId === loggedInUser.userId
				// 	);

				// 	if (!alreadyExists) {
				// 		contactsList.data.contacts.unshift({
				// 			...loggedInUser,
				// 			isSelf: true,
				// 		});
				// 	}
				// }

				// console.log("=============${LFStorageKeys.CONTACTS}_${data.selectedDomain}=========", `${LFStorageKeys.CONTACTS}_${data.selectedDomain}`, "=======contactsList.data======", contactsList.data)
				saveDataInLFStorage(`${LFStorageKeys.CONTACTS}_${data.selectedDomain}`, contactsList);
			}
			let { contacts: accepted, ignored, localContacts, sites, domainContacts } = contactsList;
			let vessels = [];
			if (sites && typeof sites === "string") {
				vessels = [...JSON.parse(sites)];
			} else {
				vessels = [...sites];
			}
			localContacts.forEach((elem) => {
				elem["contactType"] = "local";
			});

			let { directoryContacts, shipContacts, shoreContacts, allContacts } = filterContactsInCategories({
				localContacts,
				acceptedContacts: [...accepted],
				domainContacts,
			});
			let pendingContacts = accepted.filter((item) => (item.waitingForConfirmation || item.showAcceptIgnoreMsg));

			dispatch({
				type: CONTACTS_RECEIVED,
				data: {
					accepted,
					ignored,
					domainContacts,
					localContacts,
					vessels,
					pendingContacts, directoryContacts, shipContacts, shoreContacts, allContacts,
					isDataLoaded: false,
					contentList: contactsList || []
				},
			});
			const loggedInUserId = getState()?.user?.user?.userId;
			let vesselContactsProfileImages = {};
			//getting local contacts images
			let vesselImg = new Promise((resolve) => {
				vessels.forEach((element) => {
					Promise.all([getUserProfileImageUrlThumbnail(element.userId)])
						.then((profileElem) => {
							vesselContactsProfileImages[element.userId] = profileElem[0];
							return vesselContactsProfileImages;
						})
						.then((arrImg) => {
							resolve(arrImg);
						});
				});
			});
			accepted.forEach(async (elem) => {
				try {
					let img = getUserProfileImageUrlThumbnail(elem?.userId);
					let fetchAll = getState().profileImages;
					let imgObj = {};
					if (Object.keys(fetchAll).length === 0) {
						imgObj[elem?.userId] = img;
					} else {
						if (!imgObj[elem?.userId]) {
							imgObj[elem?.userId] = img;
						}
					}
					dispatch(updateProfileImage(imgObj));
				} catch (err) {
					// console.error("error in loading accepted contact images", err);
				}
			});

			ignored.forEach(async (elem) => {
				try {
					let img = getUserProfileImageUrlThumbnail(elem.userId);
					let fetchAll = getState().profileImages;
					let imgObj = {};
					if (Object.keys(fetchAll).length === 0) {
						imgObj[elem.userId] = img;
					} else {
						if (!imgObj[elem.userId]) {
							imgObj[elem.userId] = img;
						}
					}
					dispatch(updateProfileImage(imgObj));
				} catch (err) {
					console.error("error in loading accepted contact images", err);
				}
			});

			localContacts.forEach(async (elem) => {
				try {
					let img = getUserProfileImageUrlThumbnail(loggedInUserId + elem.userId);
					let fetchAll = getState().profileImages;
					let imgObj = {};
					if (Object.keys(fetchAll).length === 0) {
						imgObj[loggedInUserId + elem.userId] = img;
					} else {
						if (!imgObj[loggedInUserId + elem.userId]) {
							imgObj[loggedInUserId + elem.userId] = img;
						}
					}
					dispatch(updateProfileImage(imgObj));
				} catch (err) {
					// console.error("error in loading local contact images", err);
				}
			});

			vesselImg
				.then((data) =>
					dispatch({
						type: VESSEL_CONTACT_PROFILE_IMG,
						data: {
							vesselContactsProfileImages: data,
						},
					})
				)
				.catch((err) => {
					console.error("Error in fetching vessel contact profile images", err);
				});
		} catch (error) {
			console.error("ERROR in fetching Contacts", error);
		}
	};

export const selectedContactAction = (data) => (dispatch) => {
	dispatch({
		type: SELECTED_CONTACT,
		data,
	});
};



function searchAndDeleteContact(contactArray, userId) {
	let findIndex = contactArray.findIndex((elem) => elem.userId === userId);
	if (findIndex !== -1) {
		contactArray.splice(findIndex, 1);
	}
	return contactArray;
}

function searchAndChangeContact(contactArray, contactDetails) {
	let findIndex = contactArray.findIndex(
		(elem) => elem.userId === contactDetails.userId
	);
	if (findIndex !== -1) {
		contactDetails["contactType"] = "local";
		contactArray[findIndex] = contactDetails;
	}
	return contactArray;
}

const updateCachedContacts = async (contactDetails) => {
	let selectedDomain = store.getState().selectedDomain.userDomain;
	let contactsList =
		(await getDataFromLFStorage(
			`${LFStorageKeys.CONTACTS}_${selectedDomain}`
		)) || [];

	if (contactsList) {
		if (contactDetails.isLocalContact) {
			contactsList.localContacts = contactsList.localContacts.map((contact) =>
				contact.userId === contactDetails.userId ? contactDetails : contact
			);
		} else if (contactsList.contacts) {
			contactsList.contacts = contactsList.contacts.map((contact) =>
				contact.userId === contactDetails.userId ? contactDetails : contact
			);
		}
		saveDataInLFStorage(
			`${LFStorageKeys.CONTACTS}_${selectedDomain}`,
			contactsList
		);
	}
};

function addInContactList(contactArray, contactDetails) {
	updateCachedContacts(contactDetails);
	let findIndex = contactArray.findIndex(
		(elem) => elem.userId === contactDetails.userId
	);

	let newContactArr = cloneDeep(contactArray);

	if (contactDetails.isLocalContact) {
		contactDetails["contactType"] = "local";
	}
	if (findIndex === -1) {
		// If its new entry, we set the flag to show accept or ignore request
		// waitingForConfirmation flag is always received here in fxn props,
		// but showAcceptIgnoreMsg needs to be set here manually to display notification bell.
		if (!contactDetails?.waitingForConfirmation && !contactDetails?.showAcceptIgnoreMsg) {
			contactDetails.showAcceptIgnoreMsg = true;
		} else if (contactDetails?.waitingForConfirmation) {
			contactDetails.showAcceptIgnoreMsg = false;
		}
		newContactArr.push(contactDetails);
	} else {
		const prevContactDetails = newContactArr[findIndex];
		contactDetails.waitingForConfirmation = prevContactDetails.waitingForConfirmation;
		contactDetails.showAcceptIgnoreMsg = prevContactDetails.showAcceptIgnoreMsg;
		newContactArr[findIndex] = contactDetails;
	}
	return newContactArr;
}

export function updateContactList(rawMessage) {
	return async (dispatch, getState) => {
		let localContacts = getState().contacts.localContacts;
		let acceptedContacts = getState().contacts.accepted;
		let pendingContacts = getState().contacts.pendingContacts;
		let ignoredContacts = getState().contacts.ignored;
		let vesselContacts = getState().contacts.vessels;
		let selectedDomain = store.getState().selectedDomain.userDomain;
		let parsed_message = parseMessages(rawMessage);
		let contact = parsed_message[0].message;
		let contactDetails = { ...contact, contentType: parsed_message.contentType };
		// console.log('parsed_message', parsed_message);

		switch (rawMessage.contentType) {
			case 10002:
				deleteContactList(
					contactDetails,
					localContacts,
					acceptedContacts,
					vesselContacts,
					dispatch
				);
				break;
			case 10001: // MESSAGE_TYPE_ADD_CONTACT
			case 1001:  // 	
				addToContactList(
					contactDetails,
					localContacts,
					acceptedContacts,
					vesselContacts,
					dispatch,
					getState,
					pendingContacts
				);
				break;
			case 10003:
				ignoreContactList(
					contactDetails,
					acceptedContacts,
					ignoredContacts,
					dispatch
				);
				break;
			case 10004:
				updateContactLocal(contactDetails, localContacts, dispatch, getState);
				break;
			case 10005:
				updateContactProfileImage(
					contactDetails,
					acceptedContacts,
					dispatch,
					getState
				);
				break;

			case 10007:
				fetchContacts({ selectedDomain }, true, dispatch);
				break;

			default:
				break;
		}
	};
}

async function updateContactProfileImage(
	contactDetails,
	acceptedContacts,
	dispatch,
	getState
) {
	let img = getUserProfileImageUrlThumbnail(contactDetails.updatedUserId);
	
	let fetchAll = getState().profileImages || {};
	fetchAll[contactDetails.updatedUserId] = img;
	dispatch(updateProfileImage(fetchAll));
}

const updateProfileImages = async (contactDetails, getState, dispatch) => {
	try {
		let getAllProfileImages = cloneDeep(getState().profileImages);
		const loggedInUserId = getState().user.user.userId;
		let imgObj = {};
		if (contactDetails.isLocalContact) {
			if (getAllProfileImages) {
				let img = getUserProfileImageUrlThumbnail(loggedInUserId + contactDetails.userId)
				imgObj[loggedInUserId + contactDetails.userId] = img;
			}
		} else {
			if (getAllProfileImages) {
				let img = getUserProfileImageUrlThumbnail(contactDetails.userId)
				imgObj[contactDetails.userId] = img;
			}
		}
		dispatch(updateProfileImage(imgObj));
	} catch (err) {
		console.log("Error", err.message)
	}
}

function addToContactList(
	contactDetails,
	localContacts,
	acceptedContacts,
	vesselContacts,
	dispatch,
	getState,
	pendingContactsData
) {
	let newContactArr;
	if (contactDetails.isLocalContact) {
		newContactArr = addInContactList(localContacts, contactDetails);
		dispatch({
			type: UPDATE_CONTACT_FROM_LOCAL,
			data: [...newContactArr],
		});
	} else {
		// New contact req comes through here 
		newContactArr = addInContactList(acceptedContacts, contactDetails);
		let pendingContacts = newContactArr.filter((item) => item.waitingForConfirmation || item.showAcceptIgnoreMsg);
		let contactsAccepted = newContactArr.filter((item) => !item.waitingForConfirmation && !item.showAcceptIgnoreMsg);
		// We disable diaplaying of new contact requests. It can only be accessed from header notification bell.

		// if (contactDetails?.waitingForConfirmation === false && contactDetails?.showAcceptIgnoreMsg === false) {
		// 	dispatch(selectedContactAction(contactDetails));
		// }
		dispatch({
			type: UPDATE_CONTACT_FROM_ACCEPTED,
			data: [...contactsAccepted],
		});
		dispatch({
			type: UPDATE_PENDING_CONTACTS,
			data: { pendingContacts: [...pendingContacts] },
		});
	}
	updateProfileImages(contactDetails, getState, dispatch);
}

function ignoreContactList(
	contactDetails,
	acceptedContacts,
	ignoredContacts,
	dispatch
) {
	let removeListInAccepted = [];
	let newContactArr = [];
	removeListInAccepted = searchAndDeleteContact(
		acceptedContacts,
		contactDetails.userId
	);
	newContactArr = addInContactList(ignoredContacts, contactDetails);
	dispatch(removeSelectedContact());
	dispatch(clearAcceptIgnoreButtons());
	dispatch(clearAcceptIgnoreContact());
	dispatch({
		type: UPDATE_CONTACT_FROM_ACCEPTED,
		data: [...removeListInAccepted],
	});
	dispatch({
		type: UPDATE_IGNORED_CONTACT,
		data: [...newContactArr],
	});
}

function deleteContactList(
	contactDetails,
	localContacts,
	acceptedContacts,
	vesselContacts,
	dispatch
) {
	let newContactArr = [];
	if (contactDetails.isLocalContact) {
		newContactArr = searchAndDeleteContact(
			localContacts,
			contactDetails.userId
		);
		dispatch({
			type: UPDATE_CONTACT_FROM_LOCAL,
			data: [...newContactArr],
		});
	} else {
		newContactArr = searchAndDeleteContact(
			acceptedContacts,
			contactDetails.userId
		);

		dispatch({
			type: UPDATE_CONTACT_FROM_ACCEPTED,
			data: [...newContactArr],
		});
	}
}

function updateContactLocal(contactDetails, localContacts, dispatch, getState) {
	let newContactArr = [];
	if (contactDetails.isLocalContact) {
		newContactArr = searchAndChangeContact(localContacts, contactDetails);
		dispatch({
			type: UPDATE_CONTACT_FROM_LOCAL,
			data: [...newContactArr],
		});
	}

	updateProfileImages(contactDetails, getState, dispatch);
}

export function removeSelectedContact() {
	return (dispatch) => {
		dispatch({
			type: REMOVE_SELECTED_CONTACT,
		});
	};
}

export function removeContactStatus(contactRemovingStatus) {
	return (dispatch) => {
		dispatch({
			type: REMOVE_CONTACT_STATUS,
			contactRemovingStatus: contactRemovingStatus,
		});
	};
}

export function newContactAddedStatus(newContactCreatedStatus) {
	return (dispatch) => {
		dispatch({
			type: NEW_CONTACT_ADDED_STATUS,
			newContactCreatedStatus: newContactCreatedStatus,
		});
	};
}

export function clearContactSelection() {
	return {
		type: CLEAR_SELECTED_CONTACT,
	};
}

export function clearAcceptIgnoreContact() {
	return { type: CLEAR_ACCEPT_IGNORE_CONTACT };
}

export const syncContactsWithCache = (data) => (dispatch) => {
	dispatch({
		type: SYNC_CONTACTS_WITH_CACHE,
		data: {
			accepted: data.contacts || [],
			ignored: data.ignored || [],
			localContacts: data.localContacts || [],
			vessels: data.vessels || [],
		},
	});
};

export const updatePendingContacts = (pendingContacts) => (dispatch) => {
	dispatch({
		type: UPDATE_PENDING_CONTACTS,
		data: {
			pendingContacts,
		},
	});
};

export const updateSelectedPendingContact = (contact) => (dispatch) => {
	dispatch({
		type: UPDATE_SELECTED_PENDING_CONTACT,
		data: {
			contact
		},
	});
}

export const updateIgnoreContacts = (ignoredContacts) => (dispatch) => {
	dispatch({
		type: UPDATE_IGNORED_CONTACT,
		data: [...ignoredContacts],
	});
}